import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '@portals/core';
import { COMMA, ENTER, SPACE, TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

import { Tag } from '@portals/api';
import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { filter, map, startWith, tap } from 'rxjs/operators';
import { TagsState, AuthState } from '@portals/store';

@Component({
	selector: 'portals-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['./tag.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent extends BaseComponent {
	readonly separatorKeysCodes = [COMMA, TAB, ENTER] as const;
	tagChipsCtrl = new FormControl();
	filteredTags!: Array<Tag>;

	@ViewChild('tagInput') tagInput!: ElementRef<HTMLInputElement>;

	@Input() tags: Tag[] = [];
	@Input() source: Tag[] = [];
	@Output() tagAdded = new EventEmitter<Tag>();
	@Output() tagSelected = new EventEmitter<Tag>();
	@Output() tagRemoved = new EventEmitter<Tag>();

	get filteredTagsReversed() {
		return this.filteredTags;
	}

	constructor(private tagsState: TagsState, private user: AuthState) {
		super();
		this.subscribe(
			tagsState
				.load({
					params: {
						populate: true,
						sort: 'createdAt:desc',
						filters: {
							project: {
								id: {
									$eq: this.user?.data?.project?.id,
								},
							},
						},
					},
				})
				.pipe(
					tap(({ data }) => {
						this.filteredTags = data;
					})
				)
		);
	}

	add(event: MatChipInputEvent): void {
		const value = (event.value || '').trim();

		if (value) {
			this.tagAdded.emit({ name: value });
		}

		event.chipInput!.clear();
		this.tagChipsCtrl.setValue(null);
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		const tag = event.option.value;
		this.tagSelected.emit(tag);
		this.tagInput.nativeElement.value = '';
		this.tagChipsCtrl.setValue(null);
	}

	remove(tag: Tag): void {
		const index = this.tags!.indexOf(tag);
		if (index >= 0) {
			tag.id && this.tagRemoved.emit(tag);
		}
	}
	private _filter(value: string): Tag[] {
		const filterValue = value.toLowerCase();

		return this.source.filter((tag) => tag.name.toLowerCase().includes(filterValue));
	}
}
